<div class="zci-own-account-tile__internal-btn-group" data-cy="internal-btn-group">
    <span class="zci-own-account-tile__internal-btn-group-label">Internal only</span>
    <button
        type="button"
        c11n-link
        variant="secondary-reinforced"
        class="c11n-link zci-own-account-tile__internal-btn-group-action"
        [disabled]="hasNoGrantees"
        [attr.title]="legalFormsDisabledReason"
        (click)="openLegalForms()"
        data-cy="view-legal-forms-button">
        <span class="c11n-link__content">View legal forms</span>
    </button>
</div>

<c11n-modal-dialog-entrypoint class="zci-legal-forms-entrypoint"></c11n-modal-dialog-entrypoint>
<c11n-modal-dialog
    variant="internal"
    [headingText]="heading"
    primaryButtonLabel="Close"
    [maxWidth]="660"
    [useContentWidth]="false"
    (closeEvent)="onLegalFormsClose()"
    data-cy="legal-forms-modal"
    #legalFormsModal>
    <div c11n-modal-dialog-body class="zci-legal-forms-modal__body">
        <iframe
            *ngIf="legalFormsUrl"
            [src]="legalFormsUrl"
            class="zci-legal-forms-modal__iframe"
            title="Legal forms"
            data-cy="legal-forms-iframe">
        </iframe>
    </div>
</c11n-modal-dialog>
